module.exports = __webpack_public_path__ + "assets/img/new_my_videos_icon.7821dd00.png";